var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { computed, del, ref, set } from "vue";
import { fetchCollectionAttributes } from "@/api/datasetCollections";
export const useCollectionAttributesStore = defineStore("collectionAttributesStore", () => {
    const storedAttributes = ref({});
    const loadingAttributes = ref({});
    const getAttributes = computed(() => {
        return (hdcaId) => {
            if (!storedAttributes.value[hdcaId]) {
                set(storedAttributes.value, hdcaId, {});
                fetchAttributes({ hdcaId });
            }
            return storedAttributes.value[hdcaId];
        };
    });
    const isLoadingAttributes = computed(() => {
        return (hdcaId) => {
            var _a;
            return (_a = loadingAttributes.value[hdcaId]) !== null && _a !== void 0 ? _a : false;
        };
    });
    function fetchAttributes(params) {
        return __awaiter(this, void 0, void 0, function* () {
            set(loadingAttributes.value, params.hdcaId, true);
            try {
                const attributes = yield fetchCollectionAttributes(params);
                set(storedAttributes.value, params.hdcaId, attributes);
                return attributes;
            }
            finally {
                del(loadingAttributes.value, params.hdcaId);
            }
        });
    }
    return {
        storedAttributes,
        getAttributes,
        isLoadingAttributes,
    };
});
